var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"info-popup"},[_c('img',{staticClass:"info-popup__icon",class:{'info-popup-icon-disabled': _vm.disabled},attrs:{"src":require("assets/images/info.svg"),"alt":"i"},on:{"click":_vm.clickIt}}),_vm._v(" "),(!_vm.disabled)?_c('UiTooltip',{attrs:{"position":"top","tooltipClass":_vm.tooltipClass}},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }